import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components";

import { FlexWithSpace } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import { LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const MetricTitle = styled(LeftFlexRow)`
    ${setFontVariant("h5", carbon[500])};
`;

const MetricContainerWrapper = styled(Box)<{
    width?: string;
    height?: string;
    minHeight?: string;
    padding?: string;
    overflow?: string;
    minWidth?: string;
}>`
    ${({ width = "auto" }) => `width:${width}`};
    ${({ minWidth }) => minWidth && `min-width:${minWidth}`};
    ${({ height = "222px" }) => `height:${height}`};
    ${({ minHeight }) => minHeight && `min-height: ${minHeight};`};
    ${({ padding = "24px" }) => `padding:${padding}`};
    background-color: white;
    @media (max-width: 1400px) {
        ${({ padding = "16px" }) => `padding:${padding}`};
    }
    ${({ overflow = "hidden" }) => `overflow:${overflow}`};
`;

export const MetricContainer = ({ children, ...rest }) => {
    return <MetricContainerWrapper {...rest}>{children}</MetricContainerWrapper>;
};
export const MetricsRow = styled(FlexWithSpace)<{
    marginTop?: string;
    gap?: string;
    direction?: string;
    marginBottom?: string;
}>`
    ${({ marginTop = "0" }) => `margin-top: ${marginTop}`};
    ${({ gap = "0" }) => `gap: ${gap}`};
    ${({ direction = "column" }) => `flex-direction: ${direction}`};
    ${({ marginBottom = "24px" }) => ` margin-bottom: ${marginBottom}`};
`;
export const CarouselWrapper = styled.div`
    width: 100%;
    box-sizing: border-box;
    .carouselItemWrapper {
        &:last-child {
            flex: 1;
        }
        &:first-of-type {
            padding-bottom: 10px;
        }
    }
`;
